import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../Hooks/useTranslate';
import useAPI from '../../../../api';
import { useSetAtom } from 'jotai';
import {
  Fade,
  Paper,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Stack,
  Divider,
} from '@mui/material';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SchemaRoundedIcon from '@mui/icons-material/SchemaRounded';
import { openSnackbarAdviseAtom } from '../../../../Atoms';
import SectionPage from '../../../../Components/Paper/SectionPage';
import WaveFilterOptions from './Components/WaveFilterOptions';
import SchemaBuilder from '../SchemaBuilder';
import WaveFilterDialog from './Components/WaveFilterDialog';
import BackButton from '../BackButton';

const renderChip = ({ active, onToggle, onEdit }) => (
  <WaveFilterOptions active={active} onToggle={onToggle} onEdit={onEdit} />
);

const WaveFilters = function WaveFilters({
  show = false,
  close = () => {},
  onSave,
}) {
  const translate = useTranslate();
  const API = useAPI();
  const openSnackbar = useSetAtom(openSnackbarAdviseAtom);

  const [filters, setFilters] = useState([]);
  const [waveFilterDialog, setWaveFilterDialog] = useState(false);
  const [showSchemaBuilder, setShowSchemaBuilder] = useState(null);

  const loadWaveFilters = () => {
    API.getWaveFilters(
      (res) => {
        setFilters(res);
      },
      () => {
        setFilters([]);
      }
    );
  };

  useEffect(() => {
    if (!show) return;

    loadWaveFilters();
  }, [show]);

  const handleCloseSchemaBuilder = () => setShowSchemaBuilder(false);

  const handleOpenWaveFilterDialog = () => {
    setWaveFilterDialog(true);
  };
  const handleOpenWaveFilterDialogInEdit = (data) => {
    setWaveFilterDialog(data);
  };

  const handleCloseWaveFilterDialog = () => {
    setWaveFilterDialog(false);
  };

  const handleSelectFilter = (data) => {
    setShowSchemaBuilder(data);
  };

  const handleAddNewFilter = (data) => {
    API.createWaveFilter(data, (res) => {
      openSnackbar({
        message: translate('FILTER_CREATED_SUCCESSFULLY'),
        severity: 'success',
      });
      setFilters(res);
      handleCloseWaveFilterDialog();
    });
  };
  const handleEditFilter = (data) => {
    API.updateWaveFilter(data, (res) => {
      openSnackbar({
        message: translate('FILTER_UPDATED_SUCCESSFULLY'),
        severity: 'success',
      });
      setFilters(res);
      handleCloseWaveFilterDialog();
    });
  };

  const handleToggleFilter = (filterId) => {
    API.toggleWaveFilter(filterId, (res) => {
      setFilters((prev) =>
        prev.map((filter) =>
          filter.id === filterId
            ? { ...filter, active: !filter.active }
            : filter
        )
      );
    });
  };

  return (
    <>
      <SchemaBuilder
        show={Boolean(showSchemaBuilder)}
        close={handleCloseSchemaBuilder}
        data={showSchemaBuilder}
        onSave={handleEditFilter}
      />
      <WaveFilterDialog
        open={Boolean(waveFilterDialog)}
        onClose={handleCloseWaveFilterDialog}
        onSubmit={
          typeof waveFilterDialog === 'boolean'
            ? handleAddNewFilter
            : handleEditFilter
        }
        edit={
          typeof waveFilterDialog === 'boolean' ? undefined : waveFilterDialog
        }
      />
      <Fade in={show && !Boolean(showSchemaBuilder)} unmountOnExit={!show}>
        <div
          style={{
            display: show ? 'block' : 'none',
            height: '100%',
          }}
        >
          <SectionPage
            hideExportExcel
            hideSorting
            hideFilters
            hideSearchBar
            fab={translate('NEW_FILTER')}
            fabVariant="extended"
            onClickFab={handleOpenWaveFilterDialog}
            customClick={handleSelectFilter}
            sectionName="WAVE_FILTERS"
            singlePageList={filters}
            columns={[
              {
                id: 'name',
                label: 'FILTER_NAME',
                size: 2,
              },
              {
                id: 'description',
                size: 'grow',
              },
              {
                id: 'priority',
                label: 'PRIORITY_ORDER',
                size: 2,
              },
            ]}
            customStatusChipCallback={({ data }) =>
              renderChip({
                ...data,
                onToggle: () => handleToggleFilter(data?.id),
                onEdit: () => handleOpenWaveFilterDialogInEdit(data),
              })
            }
            sectionSubName={<BackButton label="WAVE" onClick={close} />}
          />
        </div>
      </Fade>
    </>
  );
};

export default WaveFilters;
